// src/components/reports/precon-report-builder/precon-errors.ts
export interface PreconFieldErrors {
  cover?: Record<string, string[]>;
  sections?: Record<number, Record<string, string[]>>;
  generic?: string;
}

function flatten(obj: unknown, prefix = ""): Record<string, string[]> {
  const out: Record<string, string[]> = {};
  if (!obj || typeof obj !== "object") return out;
  for (const [k, v] of Object.entries(obj as Record<string, unknown>)) {
    const path = prefix ? `${prefix}.${k}` : k;
    if (Array.isArray(v) && v.every((x) => typeof x === "string"))
      out[path] = v as string[];
    else if (v && typeof v === "object") Object.assign(out, flatten(v, path));
  }
  return out;
}

export function parsePreconErrors(body: unknown): PreconFieldErrors {
  const meta = (body as { template_metadata?: unknown } | null)
    ?.template_metadata;
  if (!meta || typeof meta !== "object") {
    const detail = (body as { detail?: unknown } | null)?.detail;
    return {
      generic:
        typeof detail === "string"
          ? detail
          : "An unexpected error occurred. Please try again.",
    };
  }
  const m = meta as { cover?: unknown; sections?: unknown };
  const out: PreconFieldErrors = {};
  if (m.cover) out.cover = flatten(m.cover);
  if (Array.isArray(m.sections)) {
    out.sections = {};
    m.sections.forEach((s, i) => {
      const f = flatten(s);
      if (Object.keys(f).length) out.sections![i] = f;
    });
  }
  return out;
}
